export default __webpack_public_path__ + "7bd6af4544e798d0a199149d7c6af1a2.png";